(function($) {
  // Site title
  $('.home .slider').slick({
    centerMode: true,
    slidesToShow: 1,
    centerPadding: '10px',
    autoplay: true,
    autoplaySpeed: 3000,
    variableWidth: true,
    prevArrow: '.slider-prev',
    nextArrow: '.slider-next',
    dots: true,
    responsive: [
    {
      breakpoint: 787,
      settings: {
        variableWidth: false,
        centerPadding: 0
      }
    }]
  });
})(jQuery);